import React from 'react';

import { InstancesCopySideNavigation } from '@lumapps/instance-copy/components/InstancesCopySideNavigation/InstancesCopySideNavigation';
import { SIDE_NAV_ID } from '@lumapps/instance/constants';
import { instances } from '@lumapps/instance/routes';
import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiCheckboxMultipleBlank } from '@lumapps/lumx/icons';
import { useTranslate } from '@lumapps/translations';

import { INSTANCE_BACK_OFFICE } from '../../keys';

export interface InstancesSideNavigationProps extends Partial<SideNavigationItemProps> {
    /** Is user allowed */
    isAllowed: boolean;
}

const InstancesSideNavigation: React.FC<InstancesSideNavigationProps> = ({ isAllowed, ...restOfProps }) => {
    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...restOfProps}
            label={translateKey(INSTANCE_BACK_OFFICE.INSTANCES_TITLE)}
            icon={mdiCheckboxMultipleBlank}
            id={SIDE_NAV_ID}
        >
            <SideNavigationItem label={translateKey(INSTANCE_BACK_OFFICE.MANAGEMENT)} route={instances()} />
            <InstancesCopySideNavigation />
        </SideNavigationItem>
    );
};

InstancesSideNavigation.displayName = 'SideNavigationItem';

export { InstancesSideNavigation };
